export interface ModuleLifecyclePermissionsItem {
  rebuild: {
    width: boolean;
    height: boolean;
    scrollHeight: boolean;
  };
}
export class ModuleLifecyclePermissions {
  desktop: ModuleLifecyclePermissionsItem = {
    rebuild: {
      width: true,
      height: true,
      scrollHeight: true,
    },
  };
  mobile: ModuleLifecyclePermissionsItem = {
    rebuild: {
      width: true,
      height: true,
      scrollHeight: true,
    },
  };
}
